import React, { useEffect, useState } from "react";
import "../BasicInformation/BasicInformation.css";
import Locations from "../Locations/Locations";
import AddressAutocomplete from "../../CustomGooglePlaceAPi/AddressAutocomplete";
import { Navigate, useNavigate } from "react-router-dom";
import Loader from "../../../CustomComponents/Loader/Loader";
import {
  AccommodationCategoryOptions,
  AccommodationStarRatingOptions,
  AccommodationTypeOptions,
} from "../../../constants";

const BasicInformation = ({
  setActiveTab,
  activeTab,
  propertyData,
  handleInputChange,
  handleNextClick,
  addressData,
  handleChangeAddressData,
  onSubmitForm,
  setFormErrors,
  formErrors,
  amenities,
  selectedAmenities,
  setSelectedAmenities,
  propertyStatus,
  setPropertyStatus,
}) => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoader(false);
    }, 500);
  }, []);

  const handleAmenityChange = (amenityName) => {
    setSelectedAmenities((prev) => {
      if (prev.includes(amenityName)) {
        return prev.filter((item) => item !== amenityName);
      } else {
        return [...prev, amenityName];
      }
    });
  };


  return (
    <section>
      <div className="mt-20">
        <div className="flex_align_center flex_gap_20" style={{ background: 'white', borderRadius: '10px', padding: '10px 15px' }}>
          <span onClick={() => navigate(-1)} className="vendor_back_btn">
            <svg xmlns="http://www.w3.org/2000/svg" style={{ margin: '0' }} width="24" height="24" viewBox="0 0 24 24" fill="none">
              <mask id="mask0_7233_11440" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                <rect width="24" height="24" transform="matrix(-1 0 0 1 24 0)" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_7233_11440)">
                <path d="M7.373 12.75H18.75C18.9628 12.75 19.141 12.6782 19.2845 12.5345C19.4282 12.391 19.5 12.2128 19.5 12C19.5 11.7872 19.4282 11.609 19.2845 11.4655C19.141 11.3218 18.9628 11.25 18.75 11.25H7.373L12.5423 6.08076C12.6909 5.93209 12.7643 5.75809 12.7625 5.55876C12.7605 5.35942 12.682 5.18217 12.527 5.02701C12.3718 4.88217 12.1962 4.80717 12 4.80201C11.8038 4.79684 11.6282 4.87184 11.473 5.02701L5.13275 11.3673C5.03908 11.4609 4.97308 11.5597 4.93475 11.6635C4.89625 11.7673 4.877 11.8795 4.877 12C4.877 12.1205 4.89625 12.2327 4.93475 12.3365C4.97308 12.4403 5.03908 12.5391 5.13275 12.6328L11.473 18.973C11.6115 19.1115 11.783 19.1823 11.9875 19.1855C12.192 19.1887 12.3718 19.1178 12.527 18.973C12.682 18.8178 12.7595 18.6397 12.7595 18.4385C12.7595 18.2372 12.682 18.0589 12.527 17.9038L7.373 12.75Z" fill="#1C1B1F" />
              </g>
            </svg>
          </span>
          <div>
            <h4 className="vendor_top_bar_title">Add your Property</h4>
            <p className="vendor_top_bar_subtitle">Please fill the details of your property.</p>
          </div>
        </div>
        {loader ? (
          <Loader size="4em" color="#009A50" />
        ) : (
          <div className="flex-div_profile_Sec">
            {/* <div className="flex-div_edit_Sec"> */}
            <div className="w-full mt-10">
              <form onSubmit={onSubmitForm}>
                <div className="bg-white-div m_0">
                  <h4>Basic Details</h4>
                  <div className="input-flex mt-10">
                    <div className="w-half">
                      <label htmlFor="">
                        Property Name <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Enter Property Name"
                        onChange={handleInputChange}
                        name="name"
                        value={propertyData.name}
                        style={
                          formErrors.name && {
                            backgroundColor: "#ff000040",
                            border: "1px solid red",
                          }
                        }
                      />
                    </div>

                    <div className="w-half">
                      <label htmlFor="rating">
                        Rating <span className="required">*</span>
                      </label>
                      <select
                        name="rating"
                        id="rating"
                        value={propertyData.rating}
                        onChange={handleInputChange}
                        style={
                          formErrors.rating && {
                            backgroundColor: "#ff000040",
                            border: "1px solid red",
                          }
                        }
                      >
                        <option value="">Select</option>
                        {AccommodationStarRatingOptions.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label} Star
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="w-half">
                      <label htmlFor="rating">
                        Type <span className="required">*</span>
                      </label>
                      <select
                        name="type"
                        id="type"
                        value={propertyData.type}
                        onChange={handleInputChange}
                        style={
                          formErrors.type && {
                            backgroundColor: "#ff000040",
                            border: "1px solid red",
                          }
                        }
                      >
                        <option value="">Select</option>
                        {AccommodationTypeOptions.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="input-flex mt-10">
                    <div className="w-half">
                      <label htmlFor="rating">
                        Featured <span className="required">*</span>
                      </label>
                      <select
                        name="featured"
                        id="type"
                        value={propertyData.featured}
                        onChange={handleInputChange}
                        style={
                          formErrors.featured && {
                            backgroundColor: "#ff000040",
                            border: "1px solid red",
                          }
                        }
                      >
                        <option value="">Select</option>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>

                    <div className="w-half">
                      <label htmlFor="rating">
                        Online <span className="required">*</span>
                      </label>
                      <select
                        name="online"
                        id="type"
                        value={propertyData.online}
                        onChange={handleInputChange}
                        style={
                          formErrors.online && {
                            backgroundColor: "#ff000040",
                            border: "1px solid red",
                          }
                        }
                      >
                        <option value="">Select</option>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>

                    <div className="w-half">
                      <label htmlFor="rating">
                        Category <span className="required">*</span>
                      </label>
                      <select
                        name="category"
                        id="type"
                        value={propertyData.category}
                        onChange={handleInputChange}
                        style={
                          formErrors.category && {
                            backgroundColor: "#ff000040",
                            border: "1px solid red",
                          }
                        }
                      >
                        <option value="">Select</option>
                        {AccommodationCategoryOptions.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* <div className="w-half">
                      <label htmlFor="rating">
                        Status <span className="required">*</span>
                      </label>
                      <select
                        name="status"
                        id="type"
                        value={propertyData.status}
                        onChange={handleInputChange}
                        style={
                          formErrors.status && {
                            backgroundColor: "#ff000040",
                            border: "1px solid red",
                          }
                        }
                      >
                        <option value="">Select</option>
                        <option value="active">Active</option>
                        <option value="draft">Draft</option>
                      </select>
                    </div> */}
                  </div>
                  <div className="input-flex mt-10">
                    {/* <div className='w-half'>
                                <label htmlFor="">When was this property Built?</label>
                                <select name="property_built" id="" onChange={handleInputChange}>
                                    <option value="">Select</option>
                                    <option value="1800-1900">1800-1900</option>
                                    <option value="1900-2000">1900-2000</option>
                                    <option value="2000-2010">2000-2010</option>
                                    <option value="2010-2020">2010-2020</option>
                                    <option value="2020-2024">2020-2024</option>
                                </select>
                            </div> */}
                  </div>

                  {/* <div className='flex flex_gap_10 w-full'>
                            <div className='w-half'>
                                <label htmlFor="">Built Year</label>
                                <input type="number" onChange={handleInputChange} name='built_year' value={propertyData.built_year} />
                            </div>
                            <div className='w-half'>
                                <label htmlFor="">No. Of Rooms<span className='required'>*</span></label>
                                <input type="number" onChange={handleInputChange} name='no_of_rooms' value={propertyData.no_of_rooms} required />
                            </div>
                        </div> */}
                  {/* <div className='flex flex_gap_10 w-full'>
                            <div className='w-half'>
                                <label htmlFor="">No. of Restaurant</label>
                                <input type="number" onChange={handleInputChange} name='resturant' value={propertyData.resturant} />
                            </div>
                            <div className='w-half'>
                                <label htmlFor="">No. Of Floors</label>
                                <input type="number" onChange={handleInputChange} name='no_of_floors' value={propertyData.no_of_floors} />
                            </div>
                        </div> */}
                  {/* <div className='flex flex_gap_10 w-full'>
                            <div className='w-half'>
                                <label htmlFor="">Currency</label>
                                <input type="text" onChange={handleInputChange} name='currency' value={propertyData.currency} />
                            </div>
                            <div className='w-half'>
                                <label htmlFor="">VCC Currency</label>
                                <input type="text" onChange={handleInputChange} name='vcc_currency' value={propertyData.vcc_currency} />
                            </div>
                            <div className='w-half'>
                                <label htmlFor="">Timezone</label>
                                <input type="text" onChange={handleInputChange} name='time_zone' value={propertyData.time_zone} />
                            </div>
                        </div> */}
                  <div className="input-flex">
                    <div className="w-half">
                      <label htmlFor="">Check-in Time</label>
                      <input
                        name="check_in_time_information"
                        value={propertyData.check_in_time_information}
                        onChange={handleInputChange}
                        type="time"
                        id=""
                      />
                      {/* <select
                  name="check_in_time_information"
                  id=""
                  onChange={handleInputChange}
                  style={
                    formErrors.check_in_time_information && {
                      backgroundColor: "#ff000040",
                      border: "1px solid red",
                    }
                  }
                >
                  <option value="">Select</option>
                  <option value="06:00 am">06:00 am</option>
                  <option value="06:30 am">06:30 am</option>
                  <option value="07:00 am">07:00 am</option>
                  <option value="07:30 am">07:30 am</option>
                  <option value="08:00 am">08:00 am</option>
                  <option value="08:30 am">08:30 am</option>
                  <option value="09:00 am">09:00 am</option>
                  <option value="09:30 am">09:30 am</option>
                  <option value="10:00 am">10:00 am</option>
                  <option value="10:30 am">10:30 am</option>
                  <option value="11:00 am">11:00 am</option>
                  <option value="11:30 am">11:30 am</option>
                  <option value="12:00 pm (noon)">12:00 pm (noon)</option>
                  <option value="12:30 pm">12:30 pm</option>
                  <option value="01:00 pm">01:00 pm</option>
                  <option value="01:30 pm">01:30 pm</option>
                  <option value="02:00 pm">02:00 pm</option>
                  <option value="02:30 pm">02:30 pm</option>
                  <option value="03:00 pm">03:00 pm</option>
                  <option value="03:30 pm">03:30 pm</option>
                  <option value="04:00 pm">04:00 pm</option>
                </select> */}
                    </div>
                    <div className="w-half">
                      <label htmlFor="">Check-out Before</label>
                      <input
                        name="check_out_time_information"
                        value={propertyData.check_out_time_information}
                        onChange={handleInputChange}
                        type="time"
                        id=""
                      />
                      {/* <select
                  name="check_out_time_information"
                  id=""
                  onChange={handleInputChange}
                  style={
                    formErrors.check_out_time_information && {
                      backgroundColor: "#ff000040",
                      border: "1px solid red",
                    }
                  }
                >
                  <option value="">Select</option>
                  <option value="06:00 am">06:00 am</option>
                  <option value="06:30 am">06:30 am</option>
                  <option value="07:00 am">07:00 am</option>
                  <option value="07:30 am">07:30 am</option>
                  <option value="08:00 am">08:00 am</option>
                  <option value="08:30 am">08:30 am</option>
                  <option value="09:00 am">09:00 am</option>
                  <option value="09:30 am">09:30 am</option>
                  <option value="10:00 am">10:00 am</option>
                  <option value="10:30 am">10:30 am</option>
                  <option value="11:00 am">11:00 am</option>
                  <option value="11:30 am">11:30 am</option>
                  <option value="12:00 pm (noon)">12:00 pm (noon)</option>
                </select> */}
                    </div>
                  </div>
                  <div className="mt-10">
                    <label htmlFor=""> Description</label>
                    <textarea
                      name="content"
                      onChange={handleInputChange}
                      value={propertyData.content}
                      id=""
                      className="w-full mt-10 vendor_description_textarea"
                      placeholder="Type here..."
                      style={
                        formErrors.content && {
                          backgroundColor: "#ff000040",
                          border: "1px solid red",
                        }
                      }
                    ></textarea>
                  </div>
                  {/* <div className='w-half'>
                            <label htmlFor="">  Do you work with Channel Manager?</label>
                            <div className="flex flex_gap_5 mt-10">
                                <div className='flex border-radius border radio-btn'><input type="radio" checked={propertyData?.channel_manager === "true"} name='channel_manager' value="true" onChange={handleInputChange} /> <label htmlFor="" className='m_0'>Yes</label></div>
                                <div className='flex border-radius border radio-btn'><input type="radio" checked={propertyData?.channel_manager === "false"} name='channel_manager' className='radio-btn' value="false" onChange={handleInputChange} /> <label htmlFor="" className='m_0'>No</label></div>
                            </div>
                        </div> */}
                </div>
                <div className="bg-white-div mt-10">
                  <h4>Contact Details</h4>
                  <div className="flex flex_gap_10 w-full mt-10">
                    <div className="w-half">
                      <label htmlFor="">
                        Mobile Number <span className="required">*</span>
                      </label>
                      <input
                        type="number"
                        placeholder="Enter Contact Number"
                        onChange={handleInputChange}
                        name="phone"
                        value={propertyData.phone}
                        style={
                          formErrors.phone && {
                            backgroundColor: "#ff000040",
                            border: "1px solid red",
                          }
                        }
                      />
                    </div>
                    <div className="w-half">
                      <label htmlFor="">
                        Email <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Enter Email"
                        onChange={handleInputChange}
                        name="email"
                        value={propertyData.email}
                        style={
                          formErrors.email && {
                            backgroundColor: "#ff000040",
                            border: "1px solid red",
                          }
                        }
                      />
                    </div>
                  </div>
                  {/* <div className="flex justify_content_end mt-10">
                            <button type='submit' className="primary_btn" style={{ width: "70px" }}>Save</button>
                        </div> */}
                </div>

                <div className="bg-white-div mt-10">
                  <h4 className="mb-10">Address Details</h4>
                  <AddressAutocomplete
                    formdata={addressData}
                    onAddressChange={handleChangeAddressData}
                  />
                </div>
                {/* <div className="flex flex_gap_10 mt-10">
                            <span>Latitude: 965423.0 </span>
                            <span>longitude: 8746532 </span>
                        </div> */}
                <div className="flex justify_content_end">
                  <button
                    type="submit"
                    className="vendor_common_property mt-10 mb-10 vendor_btn_hide_on_mobile"
                  >
                    Save Changes
                  </button>
                </div>
              </form>
            </div>

            <div className="new_ui_edit_page_sticky">
              <div className="bg-white-div new-status-toggle-wrapper mt-10">
                <label className="new-status-label">Status</label>
                <label className="new-toggle-switch">
                  <input
                    type="checkbox"
                    checked={propertyStatus === "active"}
                    onChange={(e) => setPropertyStatus(e.target.checked ? "active" : "draft")}
                  />
                  <span className="new-toggle-slider round"></span>
                </label>
              </div>

              <div className="bg-white-div mt-10 amenity_sec">
                <h4>Amenities</h4>
                {amenities && (
                  <>
                    {amenities?.map((amenity, index) => (
                      <div
                        key={index}
                        className="flex align_items_center flex_gap_10 py-5"
                      >
                        <input
                          type="checkbox"
                          id={`amenity-${index}`}
                          className="fit-width"
                          checked={selectedAmenities.includes(amenity.name)}
                          onChange={() => handleAmenityChange(amenity.name)}
                        />
                        <label htmlFor={`amenity-${index}`}>{amenity.name}</label>
                      </div>
                    ))}
                  </>
                )}
              </div>
            </div>
          </div>
          // </div>
        )}
        {/* <Locations /> */}
        <div className="flex justify_content_end">
          <button
            type="submit"
            className="vendor_common_property mt-10 mb-10 vendor_btn_hide_on_desktop"
            onClick={onSubmitForm}
          >
            Save Changes
          </button>
        </div>

      </div>
    </section>
  );
};

export default BasicInformation;
